import i18next from 'i18next';

// hasGTTAccess: whether the user has access to GTT (Buy at Target Price) —
// GoldSilver-only, gated by settings.IsTriggerOrderActive and account
// eligibility (see selectIsPriceAlertEligibleAccount). Once GTT reserves
// funds out of the Effective Balance, that figure is less meaningful, so this
// column switches to Available Balance for GTT-eligible users.
export const getHeaderData = (hasGTTAccess) => [
  {
    id: 1,
    content: i18next.t('portfolio.transactions.tableHeadings.yourTransactions'),
  },
  {
    id: 2,
    content: i18next.t('portfolio.transactions.tableHeadings.amount'),
  },
  {
    id: 3,
    content: i18next.t(
      hasGTTAccess
        ? 'portfolio.transactions.tableHeadings.availableBalance'
        : 'portfolio.transactions.tableHeadings.effectiveBalance',
    ),
  },
  {
    id: 4,
    content: i18next.t('portfolio.transactions.tableHeadings.status'),
  },
  { id: 5, content: '' },
];

export const equityHeaderData = [
  {
    id: 1,
    content: i18next.t('portfolio.transactions.tableHeadings.yourTransactions'),
  },
  {
    id: 2,
    content: i18next.t('portfolio.transactions.tableHeadings.amount'),
  },
  {
    id: 3,
    content: i18next.t('portfolio.transactions.tableHeadings.status'),
  },
  { id: 4, content: '' },
];
